/*
**  rui-progress-bar.js
**
**  rui-progress-bar component
*/
import { LitElement, html, css } from 'lit-element';
import { classMap } from 'lit-html/directives/class-map';
import { styleMap } from 'lit-html/directives/style-map';
import { ruiCommonStyles } from '../common/rui-common-styles.js';
export class RuiProgressBar extends LitElement {
    static get is() {
        return 'rui-progress-bar';
    }
    static get properties() {
        return {
            minValue: { type: Number },
            maxValue: { type: Number },
            value: { type: Number },
            displayLabel: { type: Object }
        };
    }
    constructor() {
        super();
        this.minValue = 0;
        this.maxValue = 100;
        this.value = 0;
        this.displayLabel = true;
    }
    render() {
        const fullRange = Math.max(this.maxValue - this.minValue, 1); // Don't let it get to 0 or you'll divide by zero
        const currentVal = Math.max(this.value - this.minValue, 0);
        const percentageValue = Math.min(Math.max(Math.round((currentVal / fullRange) * 100), 0), 100);
        const progressBarPercentage = percentageValue + '%';
        const progressBarTextPercentage = (100 - percentageValue) + '%';
        let progressBarStyles = {
            'width': progressBarPercentage
        };
        const labelClasses = {
            ['sr-only']: !this.displayLabel
        };
        let labelStyles = {
            'clip-path': 'inset(0 ' + progressBarTextPercentage + ' 0 0)'
        };
        return html `
            <div class="rui-progress-bar-track">
                <div class="rui-progress-bar" role="progressbar" attr.aria-valuenow="${this.value}" attr.aria-valuemin="${this.minValue}"
                    attr.aria-valuemax="${this.maxValue}" style="${styleMap(progressBarStyles)}">
                </div>
                <div class="rui-progress-bar-label-empty ${classMap(labelClasses)}">${progressBarPercentage}</div>
                <div class="rui-progress-bar-label-full ${classMap(labelClasses)}" style="${styleMap(labelStyles)}">${progressBarPercentage}</div>
            </div>
        `;
    }
    static get styles() {
        return [
            ruiCommonStyles,
            css `
                .rui-progress-bar-track {
                    background-color: var(--slider-track, #eee);
                    border-radius: 12.5px;
                    box-shadow: inset 0 1px 2px rgb(0 0 0 / 10%);
                    box-sizing: border-box;
                    height: 25px;
                    margin: 10px 0;
                    overflow: hidden;
                    position: relative;
                }

                .rui-progress-bar {
                    background-color: var(--btn-primary-bg, #3878ab);
                    border-radius: 12.5px;
                    box-shadow: inset 0 -1px 0 rgb(0 0 0 / 15%);
                    box-sizing: border-box;
                    font-family: var(--font-family, "Segoe UI", "Open Sans", "Helvetica Neue", Arial, sans-serif);
                    font-size: var(--btn-font-size-md, 14px);
                    font-weight: var(--btn-font-weight, 400);
                    height: 100%;
                    line-height: var(--btn-line-height-md, 1.42857143);
                    width: 0%;
                    padding-top: 2px;
                    text-transform: uppercase;
                }

                .rui-progress-bar-label-empty {
                    color: var(--text-regular, #181830);
                    font-weight: 600;
                    left: 0;
                    position: absolute;
                    right: 0;
                    text-align: center;
                    top: 2px;
                }

                .rui-progress-bar-label-full {
                    color: var(--btn-primary-fg, #fff);
                    font-weight: 600;
                    left: 0;
                    position: absolute;
                    right: 0;
                    text-align: center;
                    top: 2px;
                }

                @media print {
                    .rui-progress-bar {
                        background-color: #000000;
                        box-shadow: none;
                    }
                    
                    .rui-progress-bar-track {
                        background-color: #eeeeee;
                        box-shadow: none;
                    }

                    .rui-progress-bar-label-empty {
                        color: #000000;
                    }

                    .rui-progress-bar-label-full {
                        color: #ffffff;
                    }
                }
            `
        ];
    }
}
customElements.get(RuiProgressBar.is) || customElements.define(RuiProgressBar.is, RuiProgressBar);
